module.exports = __webpack_public_path__ + "img/recuperi-boavista-email-original.dca48629.png";